import React from "react";
import "./John_McSwain.css";



const John_McSwain = () => (

  <div className='John_McSwainMain'>

  <a href={"https://www.linkedin.com/in/johnmcswain/"} target={"_blank"}><h3 className="text-center" >John McSwain, III</h3></a>
 
<p className='RecP' >When I consider people I know who are inherently exploring new 
technologies, detail-oriented, and ultra thorough with their decision 
making, Charles is one of the first people who comes to mind. I was 
Charles' instructor for a Full Stack Web Development BootCamp @ Georgia 
Tech, where he proactively developed applications fueled by his desire 
to expand his technical knowledge. Charles' prior experience has helped 
him grow his web development skills quickly, and I am convinced he will 
be a significant contributor to any software development team.</p>

  </div>
);

export default John_McSwain;


// WEBPACK FOOTER //
// ./src/components/AboutMe/John_McSwain.js